import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface PayloadOption {
  key: string;
  message: string;
}
interface QuestionPayloadOption {
  prompt: string;
  type: string;
  answer: string[];
}
interface QuestionPayload {
  idNumber: number;
  summaryResult: PayloadOption;
  results: PayloadOption;
  qualifiers: {
    qualifier: PayloadOption[];
  };

  questions: {
    question: QuestionPayloadOption[];
  };
}

export const QUESTIONS_LIST_QUERY_KEY = 'QUESTIONS_LIST_QUERY_KEY';

interface Params {
  idNumber: number;
}
const useQuestionnaireFieldsQuery = ({ idNumber }: Params) => {
  const { mutateAsync, isLoading, isSuccess } = useMutation(() =>
    // TODO: return types is not exists
    api.post<QuestionPayload>(API_URL.IDOLOGY_CHALLENGE, {
      // id_number: idNumber,
    })
  );

  const handleRetiveQuestions = useCallback(async () => {
    const data = await mutateAsync();
    return data;
  }, [mutateAsync]);
  return {
    isSuccess,
    isLoading,
    handleRetiveQuestions,
  };
};

export default useQuestionnaireFieldsQuery;
